<div class="profile-refresh-nudge">
  <!-- Shield + "!" in a round tinted frame — the pitchIN convention (cf. the portfolio
       "complete your e-KYC" banner: .icon-wrapper > .pitchin-icon-shield-red). -->
  <div
    class="nudge-icon-frame tw-mx-auto tw-mb-4 tw-w-fit tw-rounded-full tw-bg-primary-light tw-p-4"
    aria-hidden="true"
  >
    <div class="pitchin-icon pitchin-icon-shield-red tw-h-8 tw-w-8"></div>
  </div>
  <h2 id="profile-refresh-title" class="nudge-title">{{ 'login.refreshNudge.title' | translate }}</h2>
  <p *ngIf="name" class="nudge-greeting">{{ 'login.refreshNudge.greeting' | translate: { name: name } }}</p>
  <p class="nudge-intro">{{ 'login.refreshNudge.intro' | translate }}</p>

  <ul class="nudge-checklist">
    <li>
      <span class="check-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M20 6L9 17l-5-5"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </span>
      <span class="check-label">{{ 'login.refreshNudge.item1' | translate }}</span>
    </li>
    <li>
      <span class="check-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M20 6L9 17l-5-5"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </span>
      <span class="check-label">{{ 'login.refreshNudge.item2' | translate }}</span>
    </li>
  </ul>

  <div class="nudge-actions">
    <button type="button" class="btn btn-primary" (click)="verify()">
      {{ 'login.refreshNudge.verify' | translate }}
    </button>
    <button type="button" class="btn btn-link nudge-later" (click)="remindLater()">
      {{ 'login.refreshNudge.later' | translate }}
    </button>
  </div>
</div>
